import React, { Fragment, useEffect, useState, useContext } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import ReactEcharts from "echarts-for-react";
import { useForm } from "react-hook-form";
import { getOnlineCabs } from "../../../Services/DispatchDashboard.service";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const OnlineCabs = ({ cityData }) => {
  const [option, setOption] = useState({});
  const [loader, setLoader] = useState(false)
  useEffect(() => {
    if (cityData.length == 0) return;
    setLoader(true)
    getOnlineCabs().then((result) => {
      if (result.data) {
        const xAxis = []
        const data = []
        for (let key in result.data) {
          const cityObj = cityData.find(element => element.id == key);
          if (cityObj) {
            xAxis.push(cityObj.label)
            data.push(result.data[key])
          }
        }
        setOption({
          xAxis: {
            type: "category",
            data: xAxis,
          },
          tooltip: {
            show: true
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: data,
              type: "bar",
            },
          ],
        });
        setLoader(false)
      }
    });
  }, [cityData]);

  return (
    <Fragment>
      {loader ? <Skeleton width={"100%"} height={"80%"} />
        : <Card className="online-cabs">
          <CardHeader>
            <div className="online-cabs-title">Online Cabs</div>
          </CardHeader>
          <CardBody>
            <ReactEcharts option={option} />
          </CardBody>
        </Card>}
    </Fragment>
  );
};

export default OnlineCabs;
